<div style="border-left-style: dashed">
  <div style="'display: table-row;'">
    <div class="btn-group btn-toggle" style="padding-left: 35%">
      <button class="btn btn-lg"  (click)="showVoiceMail()" [ngClass]="{ 'btn-default': isVoiceMail, 'btn-primary active': !isVoiceMail}">Normal</button>
      <button class="btn btn-lg" (click)="showVoiceMail()" [ngClass]="{ 'btn-default': !isVoiceMail, 'btn-primary active': isVoiceMail}">Voicemail</button>
    </div>
    <div style="text-align: center; text-align: -webkit-center; text-align: -moz-center;">
      <span> The text below is just showing an example of what the finally selected sounds should say in case of {{isVoiceMail ? 'Voicemail' : 'Normal'}}</span>
    </div>
    <div style="display: table-cell; vertical-align: top; padding-top: 20px;">
    </div>
    <div style="display: table-cell;" *ngIf="contextVariables !== []">
      <div *ngFor="let powernova of powerNova; let i = index;">
        <div *ngIf="powernova.containsAppointment !== undefined && powernova.containsAppointment === 'start'">
          <hr>
        </div>
        <powernovavalue [type]="powernova.type"
                        [voiceMessage]="powernova.model !== undefined && updatedModel !== undefined ? powernova.uiText : ''"
                        [uiText]="powernova.uiText"
                        [contextVariables]="contextVariables"
                        [model]="powernova.model"
                        [soundId]="powernova.soundId"
                        [isOnlyPreview]="isOnlyPreview"
                        [audioService]="powernova.audioService"
                        [src]="powernova.src"
                        [playSequence]="playSequence"
                        [sequenceNumber]="i"
                        (isEnded)="isEnded()"
                        [soundName]="powernova.name"
                        [isAppointment]="powernova.isAppointment"
                        (selectedNodeChange)="selectedNodeChange.emit($event)"
        ></powernovavalue>
        <div class="btn-group btn-toggle" style="padding-left: 32%" *ngIf="containsMoreThanOneLanguage && powernova.name === 'press1spanish'">
          <button class="btn btn-lg"  (click)="changeLanguage()" [ngClass]="{ 'btn-default': selectedLanguage !== 'EN', 'btn-primary active': selectedLanguage === 'EN'}">English</button>
          <button class="btn btn-lg" (click)="changeLanguage()" [ngClass]="{ 'btn-default': selectedLanguage === 'EN', 'btn-primary active': selectedLanguage !== 'EN'}">Spanish</button>
        </div>

        <div *ngIf="powernova.containsAppointment !== undefined && powernova.containsAppointment === 'end'">
          <hr>
        </div>
      </div>
    </div>
  </div>
</div>
